export const SHOWS = [
  { id: '11am', label: '11:00 AM', minutes: 11 * 60, theme: 'blue' },
  { id: '12pm', label: '12:00 PM', minutes: 12 * 60, theme: 'red' },
  { id: '5pm', label: '5:00 PM', minutes: 17 * 60, theme: 'green' },
  { id: '7pm', label: '7:00 PM', minutes: 19 * 60, theme: 'purple' },
];

const fmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kolkata',
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  weekday: 'long',
});

export function getISTParts(date = new Date()) {
  const parts = {};
  for (const p of fmt.formatToParts(date)) parts[p.type] = p.value;
  return {
    day: parts.day,
    month: parts.month,
    year: parts.year,
    hour: Number(parts.hour) % 24,
    minute: Number(parts.minute),
    second: Number(parts.second),
    weekday: parts.weekday,
  };
}

export function getShowState(parts) {
  const nowMin = parts.hour * 60 + parts.minute;
  for (const show of SHOWS) {
    if (nowMin >= show.minutes && nowMin < show.minutes + 30) {
      return { status: 'live', show };
    }
  }
  const next = SHOWS.find((s) => s.minutes > nowMin);
  if (next) return { status: 'upcoming', show: next, tomorrow: false };
  return { status: 'upcoming', show: SHOWS[0], tomorrow: true };
}

export function pad2(n) {
  return String(n).padStart(2, '0');
}

export const fmtHMS = (s) =>
  `${pad2(Math.floor(s / 3600))}:${pad2(Math.floor((s % 3600) / 60))}:${pad2(s % 60)}`;

export function getNextDraw(parts) {
  const nowSec = parts.hour * 3600 + parts.minute * 60 + parts.second;
  for (const show of SHOWS) {
    const start = show.minutes * 60;
    if (nowSec >= start && nowSec < start + 1800) return { show, secondsLeft: 0, live: true };
  }
  const next = SHOWS.find((s) => s.minutes * 60 > nowSec);
  if (next) return { show: next, secondsLeft: next.minutes * 60 - nowSec, live: false };
  return { show: SHOWS[0], secondsLeft: 86400 - nowSec + SHOWS[0].minutes * 60, live: false };
}

const IST_OFF = 5.5 * 3600000;

export function resultDisplayUntil(showId, updatedISO) {
  const idx = SHOWS.findIndex((s) => s.id === showId);
  const next = SHOWS[(idx + 1) % SHOWS.length];
  const istMs = new Date(updatedISO).getTime() + IST_OFF;
  const d = new Date(istMs);
  const dayStart = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  let target = dayStart + (next.minutes - 10) * 60000;
  if (target <= istMs) target += 86400000;
  return target - IST_OFF;
}
